/** The thickness of the border lines in model units */
export const BORDER_LINES_THICKNESS = Autodesk.Viewing.Private.convertUnits("mm", "ft", 1, 2);

/**
 * The width of the louvre frame in model units
 *
 * ```
 * ------------------
 * |xxxxxxxxxxxxxxxx|
 * |x|            |x|
 * |x|            |x|
 * |x|           >|x|< - LOUVRE_FRAME_WIDTH
 * |x|            |x|
 * |x|            |x|
 * |xxxxxxxxxxxxxxxx|
 * ------------------
 * ```
 */
export const LOUVRE_FRAME_WIDTH = Autodesk.Viewing.Private.convertUnits("mm", "ft", 1, 55);

/** Louvre grill lane width in model units */
export const LOUVRE_GRILL_LANE_WIDTH = Autodesk.Viewing.Private.convertUnits("mm", "ft", 1, 14.5);

/** The space between louvre grill lanes in model units */
export const LOUVRE_GRILL_LANE_SPACING = Autodesk.Viewing.Private.convertUnits("mm", "ft", 1, 4.5);

export const DEFAULT_BORDER_COLOR = new THREE.Vector4(
    0.13725490196078433,
    0.10196078431372549,
    0.1411764705882353,
    1.0,
);

export const TOLERANCE = 1e-3;
